/**
 * Auth0 Configuration for Web
 * Uses Auth0 Universal Login
 */

export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'apsrecruiting.us.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'yRuhHkZldvSDb6Ey9ycgCfCbJ7RVFACW',
  redirectUri: `${window.location.origin}/callback`,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'https://api.apsrecruiting.io',
  scope: 'openid profile email',
};
